import { appSettings } from "core/config";
import ApiHeaderKey from "core/constants/api-header-key";
import UrlUtils from "core/lib/url-utils";
import BaseService from "./base.service";

class BaseApiGatewayService extends BaseService {
    protected setBaseUrl(path: string) {
        this.baseUrl = UrlUtils.join(appSettings.apiGateway.url, path);
    }

    protected getRequestHeaders() {
        const headers = super.getRequestHeaders();

        headers[ApiHeaderKey.country] = this.countryCode;
        headers[ApiHeaderKey.gateway] = appSettings.apiGateway.key;

        return headers;
    }
}

export default BaseApiGatewayService;
